export function textUpperFirst(str: string) {
    return str.slice(0, 1).toLocaleUpperCase() + str.slice(1);
}
